<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>comparar dos accions de govern distintes</strong>.
    </p>
    <p>
      Recomanem usar dues <strong>fotos representatives de canvi</strong>, per a poder contrastar una amb l'altra.
    </p>
    <p>
      Sel·leccioneu una partit del llistat, o introduiu-ne un manualment si no el trobeu al llistat (coalicions o partits locals, etc.).
    </p>
    <p>
      A continuació, afegiu un text explicatiu de la situació abans i després.
    </p>
    <p>
      Aquest model de tarja accepta el següent format:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, Twitter, canals de Telegram i Whatsapp, etc.)</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'comparison-help'
}
</script>
